import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _26ab3ef2 = () => interopDefault(import('..\\pages\\complete-form.vue' /* webpackChunkName: "pages_complete-form" */))
const _281148b7 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _2c7d57b6 = () => interopDefault(import('..\\pages\\errors\\index.vue' /* webpackChunkName: "pages_errors_index" */))
const _bd1ad11c = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _47f84aa5 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _45a835d6 = () => interopDefault(import('..\\pages\\upload-document.vue' /* webpackChunkName: "pages_upload-document" */))
const _fd958fc8 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _3769aafe = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/complete-form",
    component: _26ab3ef2,
    name: "complete-form"
  }, {
    path: "/error",
    component: _281148b7,
    name: "error"
  }, {
    path: "/errors",
    component: _2c7d57b6,
    name: "errors"
  }, {
    path: "/success",
    component: _bd1ad11c,
    name: "success"
  }, {
    path: "/unlock",
    component: _47f84aa5,
    name: "unlock"
  }, {
    path: "/upload-document",
    component: _45a835d6,
    name: "upload-document"
  }, {
    path: "/errors/404",
    component: _fd958fc8,
    name: "errors-404"
  }, {
    path: "/",
    component: _3769aafe,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
